import React from "react";
import MDrawer from '@mui/material/Drawer';

const Drawer = (props) => {
    return (
        <MDrawer {...props} />
    )
}

export default React.memo(Drawer);